import { gql } from "@apollo/client"

const GET_SES_EMAIL_NOTIFICATION_STATUS_COUNTS = gql`
  query($input: SesEmailNotificationStatusCountsInput!) {
    sesEmailNotificationStatusCounts(input: $input) {
      is_ready
      has_completed
      details {
        id
        name
        description
        total	
      }
      
      summary {
        delivered
        failed
        queued
        total
        unknown
      }
    }
  }
`

export { GET_SES_EMAIL_NOTIFICATION_STATUS_COUNTS }
